// extracted by mini-css-extract-plugin
export default {"card":"kR","cardrow":"lR","cardcentered":"mR","details":"nR","imgwrapper":"oR","img":"pR","category":"qR","name":"rR","copy":"sR","detailsbtn":"tR","remove":"uR","price":"vR","netPrice":"wR","regularPrice":"xR","label":"yR"};
    if(module.hot) {
      // 1711394579313
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  